module.exports = __webpack_public_path__ + "img/nthu-logo.11588b79.png";